import { CreateClientLocationInput } from 'api';
import { NULL } from 'constants/index';

export const clientLocationCreateResponse = (values: CreateClientLocationInput) => ({
  createClientLocation: {
    ...values,
    groups_total: NULL,
    profiles_total: NULL,
    id: '-1',
    __typename: 'ClientLocation',
  },
});
